/** @module Sourcing/CopySupplierRequestMixin */
define([
	"dojo/_base/declare",
	"csi",
	"csi/comm/PostRequest",
	"csi/locale",
	"csi/sessionConstants",
	"csi/xml",
	"Sourcing"
], function(declare,csi,PostRequest,locale,sessionConstants,xml,Sourcing) {

	return declare(null, {
		productsField: null,

		/** @property {Object<string,Node>} statisticsMap - map of report nodes containing statistics for each SRLineItem in SupplierRequest */
		statisticsMap: null,

		/**
		 * @override
		 * This allows statisticsMap to be passed through to the form
		 */
		onCreatePopupParams: function(params) {
			params.statisticsMap = this.statisticsMap;
		},

		/**
		 * @override
		 * Disables Save & Copy Button
		 */
		_canRepeat: function() {
			return false;
		},

		/**
		 * @override
		 * This gets the report from SupplierRequest.Java and maps to URL
		 */
		onPreActionDeferreds: function(dfds) {
			var node = this.getNode();
			if (node && node.State === "SupplierRequestState:Generating") {
				dfds.push(
					new Promise(function(resolve, reject) {
						reject(
							new Error(locale.resource("SRCopyNotAllowedDuringIssuingState"))
						);
					})
				);
			} else {
				var self = this;
				var req = new PostRequest("Sourcing", "SupplierRequestReport");
				req.addParameter("URL", this.m_urlNode);
				var dfd = req.post().then(function(response) {
					var reportNodes = response.getNodes();
					self.statisticsMap = csi.hashArray(reportNodes, "Url");
				});
				dfds.push(dfd);
			}
		},

		/**
		 * Set the product and the default fields on copy form
		 */
		onCreatePopup: function(view) {
			this.inherited(arguments);

			this.productsField = (this.getNode().RequestType == "DataPackageContainerType:Style") ? "Styles" : "Materials";

			view.addFixedValue("RequestType", this.getNode().RequestType);
			view.addDefaultValue("Requester", sessionConstants.userUrl);

			view.addDefaultValue("IncludeQuotes", 0);
			view.addDefaultValue("IncludeSamples", 0);
		},

		/**
		 * Create SupplierItems according to form
		 */
		toWriterRequest: function() {
			let call = this.inherited(arguments);

			const fd = this.m_formData;

			let sources;
			const subtype = fd.getFieldValue("Subtype", true);
			if(!subtype || Sourcing.isSubtypeSupplierSourced(subtype)) {
				sources = fd.getFieldValue("SRSuppliers", true);
			} else {
				sources = fd.getFieldValue("SRSupplierFactories", true);
			}
			const productSources = Array.isArray(sources) ? sources : [sources];

			call.addParameter("Name",                    xml.ATTR_STRING,  fd.getFieldValue("Node Name", true))
				.addParameter("Products",                xml.ATTR_REFLIST, fd.getFieldValue(this.productsField, true))
				.addParameter("Sources",                 xml.ATTR_REFLIST, productSources)
				.addParameter("SupplierRequestTemplate", xml.ATTR_REF,     fd.getFieldValue("SRTemplate", true))
				.addParameter("DataPackageTemplate",     xml.ATTR_REF,     fd.getFieldValue("SRDPTemplate", true))
				.addParameter("Requester",               xml.ATTR_REF,     fd.getFieldValue("Requester", true))
				.addParameter("DueDate",                 xml.ATTR_TIME,    fd.getFieldValue("DueDate", true))
				.addParameter("IncludeQuotes",           xml.ATTR_ENUM,    fd.getFieldValue("IncludeQuotes", true))
				.addParameter("IncludeSamples",          xml.ATTR_ENUM,    fd.getFieldValue("IncludeSamples", true))
				.addParameter("SampleType",              xml.ATTR_ENUM,    fd.getFieldValue("SampleType", true));

			return call;
		}
	});
});
